import React, {useEffect, useState, useRef} from 'react'
import A12Y_CONST from "../common/a12yConst";
import "react-datepicker/dist/react-datepicker.css";
import Tab from "@material-ui/core/Tab";
import TabList from '@material-ui/lab/TabList';
import TabContext from '@material-ui/lab/TabContext';
import TabPanel from '@material-ui/lab/TabPanel';
import Tooltip from '@material-ui/core/Tooltip';
import viewIcon from '../assets/images/viewIcon.svg'
import PopUpIncomeExpComponent from '../components/PopUpIncomeExpComponent'
import TransferPopUpComponent from './TransferPopUpComponent';
import ReportProcessingPopupComponent from './ReportProcessingPopupComponent'
import {totalAmountFormatter} from "../util/CurrencyFormater";
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import {downloadBase64File} from "../util/Common";
import {amoutWithoutDecimal} from '../util/date_format'
import {secureClient} from "../config/axiosClient";
import LoaderFullScreen from "./LoaderFullScreenComponent";
import ErrorMessageComponent from "./ErrorMessageComponent";
import SuccessMessageComponent from "./SuccessMessageComponent";
import Multiselect from "multiselect-react-dropdown";
//import {v4 as uuidv4} from "uuid";

const theme = createTheme({
	overrides: {
	  MuiTooltip: {
		tooltip: {
		  backgroundColor: "#222"
		}
	  }
	}
  });

function InventoryListComponent(props) {
   // const [startDate, setStartDate] = useState(new Date());
	//const [endDate, setEndDate] = useState(new Date());
    const [isPopUp, setIsPopUp] = useState(false);
    const [assetData, setAssetData] = useState({});
	const [activeTab, setActiveTab] = useState('1');
	const [isAsset, setIsAsset] = useState(true);
	const [isDebt, setIsDebt] = useState(false);
    const [isTransfer, setIsTransfer] = useState(false);
	const [assetList, setAssetList] = useState([]);
	const [transferList, setTransferList] = useState([]);
	const [debtList, setDebtList] = useState([]);
    const [isTransferPopUp, setIsTransferPopUp] = useState(false);
	const [totamAmt, setTotalAmt] = useState(0)
	const [isSorted, setIsSorted] = useState(false);
	const [loading, setLoading] = useState(false);
	//const [error, setErrors] = useState(false);
	const [eventType, setEventType] = useState(A12Y_CONST.TEXT.ASSET);
	const [sortConfig, setSortConfig] = useState({key:'', order:''});
//	const [printObj, setPrintObj] = useState({});
	const refFilterAction = useRef(null);
	const refCalendarAction = useRef(null);
	const [isResponsiveFilter, setisResponsiveFilter] = useState(false);
	const [loaderFullScreenVisible, setLoaderFullScreenVisible] = useState(false);
	const [isDownloadPopUpOpen, setIsDownloadPopUpOpen] = useState(false);
	const [isNotificationPopupOpen, setIsNotificationPopupOpen] = useState(false);
	/* eslint-disable no-unused-vars */
	const [error, setErrors] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');
	/* eslint-disable no-unused-vars */
	const [transferTypeOptions, setTransferTypeOptions] = useState(false);
	const [isFilter, setIsFilter] = useState(false);
	const [isResponsiveCalendar, setisResponsiveCalendar] = useState(false);
	const [selectedTypeFilter, setSelectedTypeFilter] = useState([]);
	const [typeFilter, setTypeFilter] = useState([]);
	const [isFilterUpdated, setIsFilterUpdated] = useState(false);


	useEffect( ()=>{
		const initiliazePageData = async ()=>{
			let tab = props.tabStatus;
			if(tab !== null){
				await setIsAsset(false)
				await setIsTransfer(false)
				await setIsDebt(false)
				if(tab === A12Y_CONST.TEXT.TRANSFER){
					await getTransferData()
				}else{
					await getDebtData()
				}
			}
		}
		initiliazePageData()
	},[props.tabStatus]) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(  () => {
	  /* const assignPrintObj = async =>{
		   setPrintObj({
			   title: isAsset ? A12Y_CONST.LABEL.INVENTORY_LABEL : isTransfer ? A12Y_CONST.LABEL.TRASNFER : A12Y_CONST.LABEL.DEBTS_LIABILITIES,
			   total: totamAmt,
			   startDate: '',
			   endDate: '',
			   dependentName: props.dependent.first_name + ' ' + props.dependent.last_name,
			   advocateName: props.userInfo.first_name + ' ' + props.userInfo.last_name,
			   totalBg: isAsset || isTransfer ? 'lblTotal totalIncome' : 'lblTotal',
			   totalColor: isAsset || isTransfer ? 'greenText' : 'redText'
		   })
	   }
	   assignPrintObj()*/
	   
   }, [props.activityList, props.dependent.first_name, props.dependent.last_name, props.userInfo.first_name, props.userInfo.last_name, totamAmt,  isAsset, isTransfer, isDebt])

	useEffect( () => {
        const assignData = async ()=>{
			setAssetList(props.assetList)
			setTransferList(props.transferList)
			setDebtList(props.debtList)
			let total = 0

			if(isAsset){
				total = props.assetList.length > 0 ? await getTotalAmount(props.assetList, 'asset_value') : 0
			}
			else if(isTransfer){
				total = props.transferList.length > 0 ? await getTotalAmount(props.transferList, 'net_proceeds') : 0
			}
			else if(isDebt){
				total = props.debtList.length > 0 ? await getTotalAmount(props.debtList, 'debt_value') : 0
			}

			setTotalAmt(await totalAmountFormatter(total))
		}
		assignData();

    }, [props.assetList, props.transferList, props.debtList, isAsset, isDebt, isTransfer, totamAmt])


	/*useEffect(async () => {
		if (props.dependent) {
			setStartDate(new Date(props.dependent.reporting_period.start_date));
			setEndDate(new Date(props.dependent.reporting_period.end_date))
		}
	}, [props.dependent])*/

	/*const setStartingDate = (date) =>{
        setStartDate(date)
    }

    const setEndingDate = (date) =>{
        setEndDate(date)
    }*/

	function addInventory(){
		props.onCreate()
	}

	const handleChange = (event, newValue) => {
		setActiveTab(newValue);
	};

	useEffect(()=>{
		setLoading(props.loading)
		if(props.error){
			setErrors(props.error)
		}
	},[props.loading,props.error])
	
	const hidePopUp = () => {
        setIsPopUp(false)
    }
    const handleDeleteButton = () => {
        setIsPopUp(false)
        props.onDelete(assetData,eventType)
    }
	function deleteAsset(asset,type){
		setEventType(type)
        setAssetData(asset)
        setIsPopUp(true)
	}

	
	const viewDetails = (item,type) => {
		props.onView(item,type)
	};

	const getAssetData = async () =>{
		setErrors(false)
		setErrorMessage('')
		if(props.assetList.length > 0){
			let total = await getTotalAmount(props.assetList, 'asset_value')
			setTotalAmt(await totalAmountFormatter(total))
		}
		setActiveTab('1');
		await setIsAsset(true)
		await setIsTransfer(false)
		await setIsDebt(false)
		await setSortConfig({key:'', order:''})
		props.getAssetList();
	}
	const getTransferData = async () =>{
		setErrors(false)
		setErrorMessage('')
		setActiveTab('2');
		await setIsAsset(false)
		await setIsTransfer(true)
		await setIsDebt(false)
		await props.getTransferData()
		await setSortConfig({key:'', order:''})
		
	}
	const getDebtData = async () =>{
		setErrors(false)
		setErrorMessage('')
		setActiveTab('3');
		await setIsAsset(false)
		await setIsTransfer(false)
		await setIsDebt(true)
		props.getDebtList()
		await setSortConfig({key:'', order:''})
		// if(props.assetList.length > 0){
		// 	let total = await getTotalAmount(props.assetList, 'asset_value')
		// 	setTotalAmt(await totalAmountFormatter(total))
		// }
	}
	
	const addDebt = () =>{
		props.onAddDebt()
	}

	const getTotalAmount = (list, amtVarName) => {
		return list.length > 0 ? list.map(item => item[amtVarName]).reduce((prev, next) => parseFloat(prev) + parseFloat(next)).toFixed(2) : 0
	}

	const handleSave = async (data,fileInfo,fileBase64Info,deletedFileInfo) =>{
		props.saveTransfer(data,fileInfo,fileBase64Info,deletedFileInfo)
		//console.log('getAssets',obj);
	}
	const hideTransferPopUp = () => {
		props.onHideTransferPopUp()
    }
	const showTransferPopUp = (asset) => {
		props.onTransferClick(asset)
    }

    useEffect(()=>{
		setIsTransferPopUp(props.showTransferPopup)
	},[props.showTransferPopup])

	function sortBy(objName, objToSort, sortType) {
		let sortedArray = [];
		const tempArray = [...objToSort];
		
		if (sortType === 'acquisition_date') {
			if (isSorted) {
				sortedArray = tempArray.sort((a, b) => (
					new Date(a['acquisition_date']) - new Date(b['acquisition_date'])
				));
				setIsSorted(false)
				setSortConfig({key: sortType, order: 'active asc'})
			} else {
				sortedArray = tempArray.sort((a, b) => (
					new Date(b['acquisition_date']) - new Date(a['acquisition_date'])
				));
				setIsSorted(true)
				setSortConfig({key: sortType, order: 'active dec'})
			}
		}
		else {
			if (isSorted) {
				sortedArray = tempArray.sort((a, b) => {
					if (a[sortType] < b[sortType]) {
						return -1;
					}
					if (a[sortType] > b[sortType]) {
						return 1;
					}
					return 0;
				});
				setIsSorted(false)
				setSortConfig({key: sortType, order: 'active asc'})
			} else {
				sortedArray = tempArray.sort((b, a) => {
					if (a[sortType] < b[sortType]) {
						return -1;
					}
					if (a[sortType] > b[sortType]) {
						return 1;
					}
					return 0;
				});
				setIsSorted(true)
				setSortConfig({key: sortType, order: 'active dec'})
			}
		}

		if(objName === 'assetList'){
			setAssetList(sortedArray)
		}else if(objName === 'transferList'){
			setTransferList(sortedArray)
		}else{
			setDebtList(sortedArray)
		}
		setisResponsiveFilter(false);
	}

	const getClassNamesFor = (name) => {
		if (!sortConfig) {
			return;
		}
		return sortConfig.key === name ? sortConfig.order : '';
	};
	
	const dataChangeHandler = async (status)=>{
		props.isDataChanged(status)
	}

	const editDebts = async (item)=>{
		props.onEditDebt(item)
	}

	const viewDebtDetails = async (item)=>{
		props.onViewDebtDetails(item)
	}


	const showFilter = () => {
		setisResponsiveFilter(!isResponsiveFilter)
	}
	const hideCalendar_Filter = async (event) => {
		if (refFilterAction.current && !refFilterAction.current.contains(event.target)) {
			setisResponsiveFilter(false)
		}

		if (refCalendarAction.current && !refCalendarAction.current.contains(event.target)) {
			setisResponsiveCalendar(false)
			await filterPopUpClose();
		}
	}
	useEffect(() => {
		document.addEventListener('click', hideCalendar_Filter, true);
		return () => {
		document.removeEventListener('click', hideCalendar_Filter, true);
		};
	});
	// console.log('assetList', assetList)

	const goToInventoryOverview = ()=>{
		let tabStatus = isAsset ?  A12Y_CONST.TEXT.ASSET : isTransfer ? A12Y_CONST.TEXT.TRANSFER : A12Y_CONST.TEXT.DEBTS
		props.goToInventoryOverview(tabStatus);
	}

	var count = 0;
    const printFromBackEnd = async (includeAttachments = true) => {
        try {
			setErrors(false)
			setErrorMessage('')
			await setLoaderFullScreenVisible(true);
			let printType = isAsset ? "asset" : isTransfer ? "asset_transfer" : "liability"
			let response = await secureClient.post('pdf_report', {"dependent_id" : props.dependent.id, "report_type" : printType, "include_attachments": includeAttachments});
			if(response.data.status === A12Y_CONST.API_RESPONSE_STATUS.OK){
				if (includeAttachments) {
					await setLoaderFullScreenVisible(false);
					setIsNotificationPopupOpen(true);
				} else {
					//downloadBase64File(response.data.sr.pdf_base64, response.data.file_name)
					await setLoaderFullScreenVisible(false);
					setIsNotificationPopupOpen(true);
				}
			}else{
				setErrors(true)
				setErrorMessage(response.data.sr?.a12yErr?.message || 'Unable to generate pdf report!')
				await setLoaderFullScreenVisible(false);
			}
		}catch (e) {
			count++
			if(count <= 3){
				printFromBackEnd(includeAttachments)
			}else{
				setErrors(true)
				setErrorMessage(A12Y_CONST.ERROR_MESSAGE.NETWORK_ERROR_TRY_AGAIN)
				await setLoaderFullScreenVisible(false);
				count = 0;
			}
		}
    }

	const filterPopUpClose = async () => {
		setisResponsiveCalendar(false)
	}
	const clearFilter = async () => {
		await setIsFilter(false);
		await setisResponsiveCalendar(false);
	}
	function filterIncome() {
		setisResponsiveCalendar(false)
	}
	const showCalendar = async () => {
		setisResponsiveCalendar(!isResponsiveCalendar)
	}
	const onSelect = (selectedList, selectedItem) => {
		selectedTypeList(selectedList)
	}
	const onRemove = (selectedList, removedItem) => {
		selectedTypeList(selectedList)
	}

	const selectedTypeList = async (selectedList) => {
		var listactiveType = [];
		selectedList.map((type) => (
			listactiveType.push(type.id)
		))
		setSelectedTypeFilter(listactiveType)
		await setTypeFilter(selectedList);
	}
	useEffect( ()=>{
		const initiliazeData = async ()=>{
		await setTransferTypeOptions([
				{'title': 'Sale',label: 'Sale', value: 'Sale', key:2},
				{'title': 'Gift',label: 'Gift', value: 'Gift', key:3},
				{'title': 'Partial Sale',label: 'Partial Sale', value: 'Partial Sale', key:4}])
		}
		initiliazeData();
	},[]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
        <div className='inventoryListMain'>
			{loaderFullScreenVisible ?
				<LoaderFullScreen />
				:
				null
			}
			<h2 className="titleWithSidebar expenseTitleMargin overViewLabel responsiveListTitle marginBottom30 positionRelative inventoryListError">
				{error ?
					<div className='maxWidth600 marginLeftRightAuto'>
						<ErrorMessageComponent errorMessage={errorMessage} />
					</div>
					:
					(props.message ?
							<SuccessMessageComponent successMessage={props.message} />

							:
							null
					)

				}
				<div className='fullWidth600Col'>
					<span>{props.dependent.first_name}'s {A12Y_CONST.LABEL.INVENTORY_LABEL}</span>
					<span id={A12Y_CONST.BUTTON_ID.LEARN_MORE+A12Y_CONST.LABEL.INVENTORY_LABEL} onClick={()=>{goToInventoryOverview()}} className="titleRightContent positionAbsoute">{A12Y_CONST.LABEL.LEARN_MORE}</span>
				</div>
            </h2>
			{loading ?
				<div className="transparentLayer maxHeight150px"></div>
				:
				null
			}
			<div className="padding20 fullWidth responsiveListTableTop responsiveTalbe expenseBoxCol inventoryBoxCol">
                <div className="tableTop tableTopMain df aic ">
					<div className="tableTopLeft incomeTableTopLeft df aic">
						<span className={'icoWrap ' + (isResponsiveFilter && 'thisActive')}>
								<span onClick={showFilter} className="a12-icon filterIcon notToPrint marginRight10 hideDesktopShowMobile">
									{
										window.innerWidth > 768 ?
											<svg xmlns="http://www.w3.org/2000/svg" width="19" height="21" viewBox="0 0 19 21" fill="none">
												<path d="M9.00684 3.02734L17.0068 2.99987" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round"/>
												<path d="M1.00684 3.05493L5.00681 3.04119" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round"/>
												<circle cx="7.00688" cy="3.03444" r="2" transform="rotate(89.8032 7.00688 3.03444)" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round"/>
												<path d="M14.0308 10.0103L17.0307 9.99995" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round"/>
												<path d="M1.03076 10.0549L9.03071 10.0275" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round"/>
												<circle cx="12.0308" cy="10.0171" r="2" transform="rotate(89.8032 12.0308 10.0171)" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round"/>
												<path d="M1.05469 17.0549L3.05468 17.0481" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round"/>
												<path d="M9.05469 17.0273L17.0546 16.9999" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round"/>
												<circle cx="6.05473" cy="17.0379" r="2" transform="rotate(89.8032 6.05473 17.0379)" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round"/>
											</svg>
											:
											<svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M1.6001 1H18.4001" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
												<path d="M1.6001 6H13.6001" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
												<path d="M1.6001 11H8.8001" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
											</svg>
									}
								</span>
								<i></i>
							</span>
						{/*<span className={'icoWrap filterTextIconColoum ' + (isResponsiveCalendar && 'thisActive')}>
								<span onClick={showCalendar} className={'a12-icon dateIcon'} id='dateIcon'>
									{
										window.innerWidth > 768 ?
											<>
												{
													isFilter?
														<svg xmlns="http://www.w3.org/2000/svg" width="19" height="21" viewBox="0 0 19 21" fill="none">
															<path d="M9.00684 3.02734L17.0068 2.99987" stroke="#D96941" strokeWidth="2" strokeLinecap="round"/>
															<path d="M1.00684 3.05493L5.00681 3.04119" stroke="#D96941" strokeWidth="2" strokeLinecap="round"/>
															<circle cx="7.00688" cy="3.03444" r="2" transform="rotate(89.8032 7.00688 3.03444)" stroke="#D96941" strokeWidth="2" strokeLinecap="round"/>
															<path d="M14.0308 10.0103L17.0307 9.99995" stroke="#D96941" strokeWidth="2" strokeLinecap="round"/>
															<path d="M1.03076 10.0549L9.03071 10.0275" stroke="#D96941" strokeWidth="2" strokeLinecap="round"/>
															<circle cx="12.0308" cy="10.0171" r="2" transform="rotate(89.8032 12.0308 10.0171)" stroke="#D96941" strokeWidth="2" strokeLinecap="round"/>
															<path d="M1.05469 17.0549L3.05468 17.0481" stroke="#D96941" strokeWidth="2" strokeLinecap="round"/>
															<path d="M9.05469 17.0273L17.0546 16.9999" stroke="#D96941" strokeWidth="2" strokeLinecap="round"/>
															<circle cx="6.05473" cy="17.0379" r="2" transform="rotate(89.8032 6.05473 17.0379)" stroke="#D96941" strokeWidth="2" strokeLinecap="round"/>
														</svg>
														:
														<svg xmlns="http://www.w3.org/2000/svg" width="19" height="21" viewBox="0 0 19 21" fill="none">
															<path d="M9.00684 3.02734L17.0068 2.99987" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round"/>
															<path d="M1.00684 3.05493L5.00681 3.04119" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round"/>
															<circle cx="7.00688" cy="3.03444" r="2" transform="rotate(89.8032 7.00688 3.03444)" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round"/>
															<path d="M14.0308 10.0103L17.0307 9.99995" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round"/>
															<path d="M1.03076 10.0549L9.03071 10.0275" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round"/>
															<circle cx="12.0308" cy="10.0171" r="2" transform="rotate(89.8032 12.0308 10.0171)" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round"/>
															<path d="M1.05469 17.0549L3.05468 17.0481" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round"/>
															<path d="M9.05469 17.0273L17.0546 16.9999" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round"/>
															<circle cx="6.05473" cy="17.0379" r="2" transform="rotate(89.8032 6.05473 17.0379)" stroke="#2D6CB2" strokeWidth="2" strokeLinecap="round"/>
														</svg>
												}
											</>
											:
											<svg xmlns="http://www.w3.org/2000/svg" width="19" height="21" viewBox="0 0 19 21" fill="none">
												<path d="M9.00684 3.02734L17.0068 2.99987" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
												<path d="M1.00684 3.05493L5.00681 3.04119" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
												<circle cx="7.00688" cy="3.03444" r="2" transform="rotate(89.8032 7.00688 3.03444)" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
												<path d="M14.0308 10.0103L17.0307 9.99995" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
												<path d="M1.03076 10.0549L9.03071 10.0275" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
												<circle cx="12.0308" cy="10.0171" r="2" transform="rotate(89.8032 12.0308 10.0171)" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
												<path d="M1.05469 17.0549L3.05468 17.0481" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
												<path d="M9.05469 17.0273L17.0546 16.9999" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
												<circle cx="6.05473" cy="17.0379" r="2" transform="rotate(89.8032 6.05473 17.0379)" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
											</svg>
									}
									<span className={`filterText ${isFilter?'filterTextActive':''}`}>{A12Y_CONST.LABEL.FILTER}</span>
								</span>
								<i></i>
							</span>*/}
						<div ref={refCalendarAction}  className={`dateWrap df aic ${isResponsiveCalendar?'calendarDisplayBlock':null}`}>
							<h3 className='filterByDate'>{A12Y_CONST.LABEL.FILTERS} <span onClick={() => filterPopUpClose()}  className={`clearTextInFilterCol`}><svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none"> <path d="M6.5 5.05908L11.5558 0L13 1.44117L7.94422 6.5L13 11.5588L11.5558 13L6.5 7.94092L1.44422 13L0 11.5588L5.05578 6.5L0 1.44117L1.44422 0L6.5 5.05908Z" fill="#71767A"/></svg></span></h3>
							<div className='fullWidth typeTitleFilter'>
								<div className="txtTo fullWidth">
									{A12Y_CONST.LABEL.TYPE}
								</div>
								<div className="fullWidth typeListFilter padding20">
									<Multiselect
										options={isAsset?props.assetTypeList:isTransfer?transferTypeOptions:props.debtTypeList} // Options to display in the dropdown
										selectedValues={typeFilter} // Preselected value to persist in dropdown
										onSelect={onSelect} // Function will trigger on select event
										onRemove={onRemove} // Function will trigger on remove event
										displayValue="title" // Property name to display in the dropdown options
										showCheckbox
										avoidHighlightFirstOption={false}
									/>

								</div>
							</div>
							<div className='marginLeft10 filterButtonRow fullWidth dateColButonRow'>
								<button className={`btn-outline btn-md saveButton filterCancelButton ${isFilter?'buttonActive':''}`} onClick={clearFilter} >{A12Y_CONST.LABEL.CLEAR}</button>
								<button className={`btn-outline btn-md saveButton filterButton ${isFilterUpdated ? 'applybuttonActive':''}`} onClick={() => filterIncome()}>{A12Y_CONST.TEXT.APPLY}</button>
							</div>
						</div>
						{isResponsiveCalendar || isResponsiveFilter ?
							<div className="orerlayFilter"></div>
							:
							null
						}
						<span onClick={() => { printFromBackEnd(true); }} className="a12-icon printIcon notToPrint marginLeft10 hideDesktopShowMobile">
							<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
										<path d="M8.13504 9.42846C7.81509 9.12375 7.30871 9.13611 7.004 9.45605C6.69929 9.77599 6.71164 10.2824 7.03159 10.5871L8.13504 9.42846ZM13 15.1665L12.4483 15.7458L13 16.2713L13.5517 15.7458L13 15.1665ZM18.9684 10.5871C19.2883 10.2824 19.3007 9.77599 18.996 9.45605C18.6912 9.13611 18.1849 9.12375 17.8649 9.42846L18.9684 10.5871ZM13.8 4.33317C13.8 3.89134 13.4418 3.53317 13 3.53317C12.5582 3.53317 12.2 3.89134 12.2 4.33317L13.8 4.33317ZM7.03159 10.5871L12.4483 15.7458L13.5517 14.5872L8.13504 9.42846L7.03159 10.5871ZM13.5517 15.7458L18.9684 10.5871L17.8649 9.42846L12.4483 14.5872L13.5517 15.7458ZM13.8 15.1665L13.8 4.33317L12.2 4.33317L12.2 15.1665L13.8 15.1665Z" fill="white"/>
										<path d="M5.41669 17.3335L5.41669 18.4168C5.41669 19.6134 6.38674 20.5835 7.58335 20.5835L18.4167 20.5835C19.6133 20.5835 20.5834 19.6134 20.5834 18.4168V17.3335" stroke="white" strokeWidth="1.6" strokeLinecap="round"/>
								</svg>
						</span>
						<div ref={refFilterAction}  className={`filterDorpDownMain hideDesktopShowMobile ${isResponsiveFilter?'displayBlock':null}`}>
							<h3>{A12Y_CONST.LABEL.SORT_BY}</h3>
							{
							isAsset ?
								<ul>
									<li><span onClick={() => sortBy('assetList', assetList, 'asset_type')}  className={`${getClassNamesFor('asset_type')} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.TYPE} <i className="arrow down"></i></span></li>
									<li><span onClick={() => sortBy('assetList', assetList, 'asset_name')} className={`${getClassNamesFor('asset_name')} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.NAME} <i className="arrow down"></i></span></li>
									<li><span onClick={() => sortBy('assetList', assetList, 'acquisition_date')} className={`${getClassNamesFor('acquisition_date')} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.DATE} <i className="arrow down"></i></span></li>
								    <li><span onClick={() => sortBy('assetList', assetList, 'asset_value')} className={`${getClassNamesFor('asset_value')} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.AMOUNT} <i className="arrow down"></i></span></li>
								</ul>
								:
								null
						   }
						   {
						   isTransfer ?
								<ul>
									<li><span onClick={() => sortBy('transferList', transferList, 'asset_type')} className={`${getClassNamesFor('asset_type')} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.TYPE} <i className="arrow down"></i></span></li>
									<li><span onClick={() => sortBy('transferList', transferList, 'asset_name')} className={`${getClassNamesFor('asset_name')} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.NAME} <i className="arrow down"></i></span></li>
									<li><span onClick={() => sortBy('transferList', transferList, 'transfer_date')} className={`${getClassNamesFor('transfer_date')} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.DATE} <i className="arrow down"></i></span></li>
									<li><span onClick={() => sortBy('transferList', transferList, 'net_proceeds')} className={`${getClassNamesFor('net_proceeds')} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.AMOUNT} <i className="arrow down"></i></span></li>
								</ul>
								:
								null
						   }
							{
								isDebt?
									<ul>
										<li><span onClick={() => sortBy('debtList', debtList, 'debt_type')} className={`${getClassNamesFor('debt_type')} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.TYPE} <i className="arrow down"></i></span></li>
										<li><span onClick={() => sortBy('debtList', debtList, 'owed_to')}  className={`${getClassNamesFor('owed_to')} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.NAME} <i className="arrow down"></i></span></li>
										<li><span onClick={() => sortBy('debtList', debtList, 'as_of_date')} className={`${getClassNamesFor('as_of_date')} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.DATE} <i className="arrow down"></i></span></li>
										<li><span onClick={() => sortBy('debtList', debtList, 'debt_value')} className={`${getClassNamesFor('debt_value')} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.AMOUNT} <i className="arrow down"></i></span></li>
									</ul>
									:
									null
							}
						</div>
					</div>
					<div className="tableTopRight df mla">
						<span className={`${isAsset || isTransfer ? 'lblTotal totalIncome' : 'lblTotal'} marginRight20 df aic jcc`}>{A12Y_CONST.LABEL.TOTAL}{A12Y_CONST.TEXT.COLON} <span className={isTransfer ? "marginLeft10 greenText" : isAsset ? "marginLeft10 greenText" : "marginLeft10 redText"}>{ totamAmt }</span></span>
							<button disabled={isAsset ? assetList.length === 0 : isTransfer ? transferList.length === 0 : debtList.length === 0} id={!isDebt ? A12Y_CONST.LABEL.INVENTORY_LABEL+A12Y_CONST.TEXT.DOWNLOAD:A12Y_CONST.LABEL.DEBT+A12Y_CONST.TEXT.DOWNLOAD} className="btn-outline saveButton marginRight20 displayNone600 printButton" onClick={() => { printFromBackEnd(true); }}>{A12Y_CONST.TEXT.DOWNLOAD}</button>
                        
						{props.dependent?.access && props.dependent.access.can_update === true && !isDebt ?
						<button id={A12Y_CONST.TEXT.ADD+A12Y_CONST.LABEL.INVENTORY_LABEL} className="btn-primary saveButton plusIcon" onClick={addInventory}><span>+</span> <span className='displayNone600' >{A12Y_CONST.LABEL.ASSET}</span></button>
							:
							null
                        }
						{props.dependent?.access && props.dependent.access.can_update === true && isDebt?
						<button id={A12Y_CONST.TEXT.ADD+A12Y_CONST.LABEL.DEBT} className="btn-primary saveButton plusIcon" onClick={addDebt}><span>+</span> <span className='displayNone600' >{A12Y_CONST.LABEL.DEBT}</span></button>
							:
							null
                        }
					</div>
				</div>
            </div>
			<div className="tableBody responsiveTalbe expenseTableTitle">
				<div className='fullWidth'>
					
					<TabContext className='fullWidth' value={activeTab}>
						<TabList onChange={handleChange} aria-label="lab API tabs example">
							<Tab className='attachTxt' onClick={getAssetData} label="Assets" value="1" />
							<Tab className='attachTxt' onClick={getTransferData} label="Transfers" value="2" />
							<Tab className='attachTxt' onClick={getDebtData} label={window.width > 768  ? 'Debts/Liabilities':'Liabilities'} value="3" />
						</TabList>
						<TabPanel value="1">

							{
							props.loadingAsset ?
								<div className='noData df aic jcc fcol'>
									<div className="positionRelative">
										<div className="dependentLoader">
											<div className='fullWidth justifyCenter marginBottom10'>
												<div className="stage">
													<div className="dot-pulse"></div>
												</div>
											</div>
										</div>
										<div className='marginTop20'>
											<span>{A12Y_CONST.TEXT.LOADING_ASSETS}</span>
										</div>
									</div>
								</div>
								:
								<div className="tableBody responsiveTalbe activityTableTitle" id='Printable'>
									
									{
										assetList.length > 0 ?
											(<table cellSpacing="0" cellPadding="0" border="0" className="fullWidth assetTable" id="TableContent">
													<thead className='mt20'>
													<tr>
														<th className='dateCol'><span onClick={() => sortBy('assetList', assetList, 'acquisition_date')} className={`${getClassNamesFor('acquisition_date')} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.ACQUIRED} <i className="arrow down"></i></span></th>
														<th><span onClick={() => sortBy('assetList', assetList, 'asset_name')} className={`${getClassNamesFor('asset_name')} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.ASSET_NAME}<i className="arrow down"></i></span></th>
														<th className='typeCol'><span onClick={() => sortBy('assetList', assetList, 'asset_type')} className={`${getClassNamesFor('asset_type')} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.ASSET_TYPE}<i className="arrow down"></i></span></th>
														<th className='inventoryAmountCol'><span onClick={() => sortBy('assetList', assetList, 'asset_value')} className={`${getClassNamesFor('asset_value')} filterBy df aic cursorPointer tar-print`}>{A12Y_CONST.LABEL.AMOUNT} <i className="arrow down"></i></span></th>
														{props.dependent?.access && props.dependent.access.can_update === true
															?
															<th className='tagCol notToPrint'>{A12Y_CONST.LABEL.TRASNFER}</th>
															:
															null
														}
														<th className='actCol notToPrint'></th>
													</tr>
													</thead>
													<tbody>
													{
														assetList.map((item, i) => {
																return (
																	<tr key={i}>
																		<td><span onClick={() => viewDetails(item,A12Y_CONST.TEXT.ASSET)} className="h100 df aic cursorPointer">{item?.acquisition_date ? item.acquisition_date : null}</span></td>
																		<td className='ellipsis'><span onClick={() => viewDetails(item,A12Y_CONST.TEXT.ASSET)} className="h100 df aic cursorPointer">{item.asset_type === 'Automobile' ? item?.automobile?.model_year+' '+item?.automobile?.make+' '+item?.automobile?.model: item.asset_name}</span></td>
																		<td className='ellipsis'><span onClick={() => viewDetails(item,A12Y_CONST.TEXT.ASSET)} className="h100 df aic cursorPointer">{item.asset_type}</span></td>
																		<td><span onClick={() => viewDetails(item,A12Y_CONST.TEXT.ASSET)} className="h100 df aic cursorPointer nowrap tar-print">{amoutWithoutDecimal(item.asset_value)}</span></td>
																		{props.dependent?.access && props.dependent.access.can_update === true
																			?
																		<td className='texAlingCener notToPrint'>
																		<span
																				id={item.id+A12Y_CONST.BUTTON_ID.TRANSFER}
																				className='blueText cursorPointer' onClick={() => {
																				showTransferPopUp(item)
																			}}>
																			<svg width="33" height="22" viewBox="0 0 33 22" fill="none" xmlns="http://www.w3.org/2000/svg">
																			<path d="M31.8689 10.6637C30.413 8.81784 28.9592 6.97086 27.5076 5.12277C26.492 3.83407 25.479 2.54574 24.4685 1.25777C24.4358 1.21619 24.2617 1.01053 24.0441 1.00615C23.4043 0.996307 22.7764 0.9974 22.1105 0.998494H21.3205V5.23545H20.6349C19.8602 5.23545 19.129 5.22998 18.3858 5.2442C18.2803 5.25226 18.1745 5.23236 18.079 5.18648C17.9835 5.1406 17.9017 5.07035 17.8417 4.98274C15.4184 2.10778 12.3716 0.970047 8.78511 1.60236C7.4396 1.84043 6.16225 2.3718 5.0428 3.15914C3.92335 3.94649 2.98895 4.97071 2.30524 6.15986C1.60258 7.36942 1.17193 8.71901 1.04353 10.1138C0.915138 11.5086 1.09212 12.9147 1.56204 14.2334C2.29739 16.2757 3.70033 18.0066 5.54137 19.1431C7.37188 20.2854 9.53859 20.7573 11.6752 20.4789C14.1779 20.1397 16.2595 18.9593 17.8613 16.9782C17.9129 16.9002 17.9846 16.8378 18.0687 16.7976C18.1529 16.7573 18.2462 16.7407 18.339 16.7495C18.9657 16.7615 19.6001 16.7594 20.2149 16.7583C20.5 16.7583 20.7862 16.7583 21.0724 16.7583C21.154 16.7583 21.2389 16.7583 21.3346 16.767V20.9919H21.5522H22.2204C22.7644 20.9919 23.2737 20.9854 23.7895 21.0018H23.8297C23.9772 21.0054 24.1232 20.9712 24.254 20.9025C24.3847 20.8338 24.496 20.7328 24.5773 20.609C25.0125 20.0467 25.4543 19.4812 25.883 18.9331L26.3596 18.327L27.2737 17.1641C28.7847 15.2387 30.2969 13.3141 31.8101 11.3901L31.8275 11.3694C31.9342 11.2337 32.1268 10.9908 31.8689 10.6637ZM18.9864 15.2726C20.3129 12.3966 20.315 9.59821 18.9951 6.73966H22.8036V2.51474H22.883C23.1007 2.51474 23.2933 2.50927 23.4804 2.52459C23.5355 2.53988 23.5846 2.57199 23.6208 2.61648C25.7492 5.31531 27.8645 8.00976 30.2106 10.9985L26.1322 16.1894C25.4068 17.1185 24.6781 18.0473 23.9462 18.9757C23.5109 19.5227 23.4815 19.5676 22.8275 19.4669V15.2726H18.9864ZM10.4804 19.0337C9.42895 19.0367 8.38735 18.8297 7.41604 18.4248C6.44473 18.0199 5.56304 17.4252 4.82211 16.6751C4.07935 15.9235 3.49232 15.0311 3.09504 14.0497C2.69775 13.0684 2.49809 12.0175 2.50764 10.958C2.52396 6.52962 6.10502 2.93373 10.4978 2.94795C11.5533 2.94413 12.5989 3.15201 13.5735 3.55945C14.5481 3.96688 15.432 4.56568 16.1736 5.32078C16.9161 6.07808 17.5026 6.9754 17.8992 7.9612C18.2958 8.94701 18.4948 10.0019 18.4848 11.0652C18.4727 13.1885 17.623 15.2202 16.1223 16.7142C14.6215 18.2082 12.5924 19.0425 10.4804 19.0337Z" fill="#2D6CB2"/>
																			<path d="M31.9474 10.6018L31.9474 10.6018C32.0939 10.7877 32.1192 10.9615 32.082 11.1123C32.0477 11.2512 31.9623 11.3598 31.9101 11.4262L31.9062 11.4312L31.9042 11.4336L31.9042 11.4336L31.8878 11.4532C30.3749 13.3767 28.8631 15.3009 27.3523 17.2259L27.3523 17.2259L26.4383 18.3888L26.4383 18.3888L25.9618 18.9947C25.9618 18.9947 25.9617 18.9948 25.9617 18.9949C25.5338 19.5419 25.093 20.1062 24.6587 20.6673C24.5683 20.8037 24.4451 20.9151 24.3005 20.991C24.155 21.0675 23.9927 21.1056 23.8286 21.1018H23.7895H23.7863L23.7863 21.1017C23.3883 21.0891 22.9946 21.0901 22.5836 21.0913C22.4642 21.0916 22.3433 21.0919 22.2204 21.0919H21.5522H21.3346H21.2346V20.9919V16.8606C21.179 16.8583 21.126 16.8583 21.0724 16.8583H21.0707H21.069H21.0673H21.0657H21.064H21.0623H21.0606H21.059H21.0573H21.0556H21.0539H21.0523H21.0506H21.0489H21.0472H21.0455H21.0439H21.0422H21.0405H21.0388H21.0372H21.0355H21.0338H21.0321H21.0305H21.0288H21.0271H21.0254H21.0238H21.0221H21.0204H21.0187H21.017H21.0154H21.0137H21.012H21.0103H21.0087H21.007H21.0053H21.0036H21.002H21.0003H20.9986H20.9969H20.9952H20.9936H20.9919H20.9902H20.9885H20.9869H20.9852H20.9835H20.9818H20.9802H20.9785H20.9768H20.9751H20.9734H20.9718H20.9701H20.9684H20.9667H20.9651H20.9634H20.9617H20.96H20.9584H20.9567H20.955H20.9533H20.9516H20.95H20.9483H20.9466H20.9449H20.9433H20.9416H20.9399H20.9382H20.9366H20.9349H20.9332H20.9315H20.9299H20.9282H20.9265H20.9248H20.9231H20.9215H20.9198H20.9181H20.9164H20.9148H20.9131H20.9114H20.9097H20.9081H20.9064H20.9047H20.903H20.9014H20.8997H20.898H20.8963H20.8946H20.893H20.8913H20.8896H20.8879H20.8863H20.8846H20.8829H20.8812H20.8796H20.8779H20.8762H20.8745H20.8728H20.8712H20.8695H20.8678H20.8661H20.8645H20.8628H20.8611H20.8594H20.8578H20.8561H20.8544H20.8527H20.8511H20.8494H20.8477H20.846H20.8443H20.8427H20.841H20.8393H20.8376H20.836H20.8343H20.8326H20.8309H20.8293H20.8276H20.8259H20.8242H20.8226H20.8209H20.8192H20.8175H20.8159H20.8142H20.8125H20.8108H20.8091H20.8075H20.8058H20.8041H20.8024H20.8008H20.7991H20.7974H20.7957H20.7941H20.7924H20.7907H20.789H20.7874H20.7857H20.784H20.7823H20.7807H20.779H20.7773H20.7756H20.7739H20.7723H20.7706H20.7689H20.7672H20.7656H20.7639H20.7622H20.7605H20.7589H20.7572H20.7555H20.7538H20.7522H20.7505H20.7488H20.7471H20.7455H20.7438H20.7421H20.7404H20.7388H20.7371H20.7354H20.7337H20.732H20.7304H20.7287H20.727H20.7253H20.7237H20.722H20.7203H20.7186H20.717H20.7153H20.7136H20.7119H20.7103H20.7086H20.7069H20.7052H20.7036H20.7019H20.7002H20.6985H20.6969H20.6952H20.6935H20.6918H20.6902H20.6885H20.6868H20.6851H20.6835H20.6818H20.6801H20.6784H20.6768H20.6751H20.6734H20.6717H20.67H20.6684H20.6667H20.665H20.6633H20.6617H20.66H20.6583H20.6566H20.655H20.6533H20.6516H20.6499H20.6483H20.6466H20.6449H20.6432H20.6416H20.6399H20.6382H20.6365H20.6349H20.6332H20.6315H20.6298H20.6282H20.6265H20.6248H20.6231H20.6215H20.6198H20.6181H20.6164H20.6148H20.6131H20.6114H20.6097H20.6081H20.6064H20.6047H20.603H20.6014H20.5997H20.598H20.5963H20.5947H20.593H20.5913H20.5896H20.588H20.5863H20.5846H20.5829H20.5813H20.5796H20.5779H20.5762H20.5746H20.5729H20.5712H20.5695H20.5679H20.5662H20.5645H20.5628H20.5612H20.5595H20.5578H20.5561H20.5545H20.5528H20.5511H20.5494H20.5478H20.5461H20.5444H20.5428H20.5411H20.5394H20.5377H20.5361H20.5344H20.5327H20.531H20.5294H20.5277H20.526H20.5243H20.5227H20.521H20.5193H20.5176H20.516H20.5143H20.5126H20.5109H20.5093H20.5076H20.5059H20.5042H20.5026H20.5009H20.4992H20.4975H20.4959H20.4942H20.4925H20.4909H20.4892H20.4875H20.4858H20.4842H20.4825H20.4808H20.4791H20.4775H20.4758H20.4741H20.4724H20.4708H20.4691H20.4674H20.4657H20.4641H20.4624H20.4607H20.4591H20.4574H20.4557H20.454H20.4524H20.4507H20.449H20.4473H20.4457H20.444H20.4423H20.4406H20.439H20.4373H20.4356H20.434H20.4323H20.4306H20.4289H20.4273H20.4256H20.4239H20.4222H20.4206H20.4189H20.4172H20.4155H20.4139H20.4122H20.4105H20.4089H20.4072H20.4055H20.4038H20.4022H20.4005H20.3988H20.3971H20.3955H20.3938H20.3921H20.3905H20.3888H20.3871H20.3854H20.3838H20.3821H20.3804H20.3787H20.3771H20.3754H20.3737H20.3721H20.3704H20.3687H20.367H20.3654H20.3637H20.362H20.3603H20.3587H20.357H20.3553H20.3537H20.352H20.3503H20.3486H20.347H20.3453H20.3436H20.3419H20.3403H20.3386H20.3369H20.3353H20.3336H20.3319H20.3302H20.3286H20.3269H20.3252H20.3236H20.3219H20.3202H20.3185H20.3169H20.3152H20.3135H20.3119H20.3102H20.3085H20.3068H20.3052H20.3035H20.3018H20.3001H20.2985H20.2968H20.2951H20.2935H20.2918H20.2901H20.2884H20.2868H20.2851H20.2834H20.2818H20.2801H20.2784H20.2767H20.2751H20.2734H20.2717H20.2701H20.2684H20.2667H20.265H20.2634H20.2617H20.26H20.2584H20.2567H20.255H20.2534H20.2517H20.25H20.2483H20.2467H20.245H20.2433H20.2417H20.24H20.2383H20.2366H20.235H20.2333H20.2316H20.23H20.2283H20.2266H20.2249H20.2233H20.2216H20.2199H20.2183H20.2166L20.2151 16.8583L20.2149 16.8583M31.9474 10.6018L18.339 16.7495C18.9224 16.7607 19.5124 16.7596 20.0871 16.7585C20.1298 16.7584 20.1724 16.7583 20.2149 16.7583V16.8583M31.9474 10.6018C30.4915 8.75597 29.0378 6.90903 27.5863 5.061L27.5862 5.06087C26.5706 3.77223 25.5576 2.48395 24.5471 1.19604L24.5471 1.19601C24.5278 1.17142 24.4702 1.10263 24.3864 1.03855C24.3036 0.975336 24.1852 0.90897 24.0461 0.906172L24.0456 0.906165C23.4085 0.896361 22.7834 0.897388 22.1219 0.898475L22.1105 0.898494H22.1104H21.3205H21.2205V0.998494V5.13545M31.9474 10.6018L21.2205 5.13545M20.2149 16.8583C20.1724 16.8583 20.1298 16.8584 20.0871 16.8585C19.5127 16.8596 18.9216 16.8607 18.3371 16.8495L18.3295 16.8493L18.3295 16.8491C18.2549 16.842 18.1797 16.8553 18.1119 16.8878C18.0442 16.9202 17.9863 16.9705 17.9446 17.0334L17.9394 17.0413L17.939 17.041C16.3215 19.0418 14.217 20.2354 11.6886 20.578L11.6881 20.578C9.52861 20.8594 7.33871 20.3826 5.48863 19.2281C3.62838 18.0797 2.21091 16.3307 1.46796 14.2672L1.46785 14.2669C0.993043 12.9346 0.814229 11.5139 0.943955 10.1046C1.07367 8.69547 1.50875 7.33194 2.21865 6.10984C2.9096 4.90815 3.85391 3.87307 4.98527 3.07735C6.11668 2.28159 7.40772 1.74452 8.76769 1.50389L8.76775 1.50388C12.3908 0.86513 15.4728 2.01718 17.9182 4.91829L17.9246 4.92594L17.9242 4.92622C17.9743 4.99943 18.0427 5.05807 18.1223 5.09634C18.202 5.13462 18.2902 5.15121 18.3781 5.14449L18.3838 5.14406L18.3839 5.14422C18.9652 5.13309 19.5395 5.134 20.1317 5.13492C20.2978 5.13518 20.4654 5.13545 20.6349 5.13545H21.2205M20.2149 16.8583L21.2205 5.13545M5.54137 19.1431C7.37188 20.2854 9.53859 20.7573 11.6752 20.4789C14.1779 20.1397 16.2595 18.9593 17.8613 16.9782L5.54137 19.1431ZM5.54137 19.1431C3.70033 18.0066 2.29739 16.2757 1.56204 14.2334C1.09212 12.9147 0.915138 11.5086 1.04353 10.1138C1.17193 8.71901 1.60258 7.36942 2.30524 6.15986L5.54137 19.1431ZM19.1416 15.1726C20.3943 12.3674 20.3967 9.62884 19.1504 6.83966H22.8036H22.9036V6.73966V2.61472C22.9441 2.61467 22.9834 2.61445 23.0217 2.61425C23.1806 2.61339 23.3226 2.61262 23.4618 2.62342C23.4934 2.63386 23.5215 2.65311 23.5428 2.67908C25.6563 5.35898 27.7569 8.03459 30.0834 10.9985L26.0536 16.1276L26.0534 16.1279C25.3281 17.0569 24.5995 17.9855 23.8676 18.9138L23.8589 18.9248C23.7536 19.0572 23.6755 19.1553 23.6066 19.2292C23.5364 19.3045 23.4817 19.3478 23.4266 19.3736C23.3254 19.4208 23.2015 19.4201 22.9275 19.3808V15.2726V15.1726H22.8275H19.1416ZM10.4808 18.9337L10.4802 18.9337C9.44198 18.9366 8.41356 18.7323 7.45452 18.3325C6.49547 17.9327 5.62488 17.3455 4.89325 16.6048L4.89324 16.6048C4.15978 15.8626 3.58007 14.9814 3.18773 14.0122C2.79538 13.0431 2.59821 12.0053 2.60763 10.9589L2.60764 10.9584C2.62376 6.58426 6.16084 3.03391 10.4975 3.04796L10.4982 3.04795C11.5403 3.04418 12.5727 3.24943 13.5349 3.65171C14.4972 4.05398 15.3699 4.64521 16.1022 5.39079C16.8355 6.13869 17.4147 7.0249 17.8064 7.99853C18.1981 8.97217 18.3947 10.014 18.3848 11.0643L18.3848 11.0647C18.3728 13.1616 17.5337 15.168 16.0517 16.6433C14.5698 18.1187 12.5662 18.9423 10.4808 18.9337Z" stroke="#2D6CB2" strokeOpacity="0.99" strokeWidth="0.2"/>
																			<path d="M12.8401 11.3757C13.4092 12.0988 13.5844 12.9751 13.321 13.7825C13.0577 14.5898 12.3755 15.2145 11.4625 15.465C11.2296 15.5284 11.2253 15.5678 11.2383 15.7636C11.2558 16.0164 11.2514 16.2647 11.2481 16.5294C11.2481 16.6388 11.2481 16.7603 11.2481 16.8795V17.0983H9.76392V15.6247L7.7291 14.9683L8.36131 13.73L8.518 13.7562C8.73563 13.7912 8.94346 13.8284 9.15021 13.8656C9.64531 13.9542 10.1132 14.0374 10.5833 14.0844C10.8085 14.1052 11.0806 14.0078 11.345 13.9006C11.7367 13.7376 11.9271 13.463 11.9271 13.0615C11.9271 12.3855 11.6268 12.1984 11.4005 12.1153C10.8564 11.9183 10.2862 11.7586 9.73454 11.6044L9.59526 11.565C8.21767 11.1777 7.46251 10.1877 7.57676 8.91539C7.67143 7.85205 8.29058 7.06876 9.41898 6.58632C9.52267 6.54364 9.62877 6.50711 9.73672 6.47692H9.75522V4.87207H11.234V6.32487L13.4908 7.3893L12.3961 8.64737L12.2329 8.51609C11.6138 8.01833 11.0751 7.82251 10.4843 7.88268C9.89341 7.94285 9.50494 8.15727 9.23617 8.56422C9.14843 8.68676 9.09009 8.82806 9.06574 8.97705C9.04139 9.12604 9.05168 9.27867 9.0958 9.423C9.1462 9.55975 9.22746 9.68289 9.33319 9.78274C9.43892 9.88258 9.56625 9.95641 9.70516 9.99842C9.97461 10.088 10.2485 10.1636 10.5256 10.2249C10.679 10.261 10.8314 10.2982 10.9837 10.3343C11.6486 10.5202 12.3461 10.75 12.8401 11.3757Z" fill="#2D6CB2"/>
																			<path d="M12.9186 11.3138L12.9187 11.3139C13.5064 12.0606 13.6908 12.9713 13.4161 13.8135C13.1412 14.6562 12.4307 15.303 11.489 15.5614L11.4888 15.5615C11.4317 15.577 11.3949 15.5895 11.3704 15.6012C11.3467 15.6124 11.3418 15.6195 11.3411 15.6207C11.3403 15.6217 11.3364 15.6275 11.3349 15.6501C11.3332 15.6744 11.3348 15.7067 11.3381 15.757L11.2383 15.7636M12.9186 11.3138L9.5682 11.6613L9.70733 11.7006L9.70761 11.7007C10.2598 11.8551 10.8263 12.0138 11.3662 12.2092C11.4695 12.2472 11.5807 12.3055 11.6679 12.425C11.7554 12.5449 11.8271 12.7381 11.8271 13.0615C11.8271 13.2459 11.7837 13.3941 11.7008 13.5135C11.6177 13.6333 11.4895 13.7321 11.307 13.8081C11.0389 13.9168 10.7897 14.0029 10.5928 13.9849C10.1274 13.9383 9.66341 13.8559 9.16792 13.7672C8.9613 13.73 8.75272 13.6927 8.53418 13.6575C8.53408 13.6575 8.53398 13.6575 8.53388 13.6575L8.37783 13.6313L8.30556 13.6192L8.27224 13.6845L7.64004 14.9229L7.58664 15.0275L7.6984 15.0635L9.66392 15.6975V17.0983V17.1983H9.76392H11.2481H11.3481V17.0983V16.8795V16.8788V16.8781V16.8774V16.8767V16.876V16.8753V16.8746V16.8739V16.8732V16.8725V16.8718V16.8711V16.8704V16.8697V16.869V16.8683V16.8676V16.8669V16.8662V16.8655V16.8648V16.8641V16.8634V16.8627V16.862V16.8613V16.8606V16.8599V16.8592V16.8585V16.8578V16.8571V16.8564V16.8557V16.855V16.8543V16.8536V16.8529V16.8522V16.8515V16.8508V16.8501V16.8494V16.8487V16.848V16.8473V16.8466V16.8459V16.8452V16.8445V16.8438V16.8431V16.8424V16.8417V16.841V16.8403V16.8396V16.8389V16.8382V16.8375V16.8368V16.8361V16.8354V16.8347V16.834V16.8333V16.8326V16.8319V16.8312V16.8305V16.8298V16.8291V16.8284V16.8277V16.827V16.8263V16.8256V16.8249V16.8242V16.8235V16.8228V16.8221V16.8214V16.8207V16.82V16.8193V16.8186V16.8179V16.8172V16.8165V16.8158V16.8151V16.8144V16.8137V16.813V16.8123V16.8116V16.8109V16.8102V16.8095V16.8088V16.8081V16.8074V16.8067V16.806V16.8053V16.8046V16.8039V16.8032V16.8025V16.8018V16.8011V16.8004V16.7997V16.799V16.7983V16.7976V16.7969V16.7962V16.7955V16.7948V16.7941V16.7934V16.7927V16.792V16.7913V16.7906V16.7899V16.7892V16.7885V16.7878V16.7871V16.7864V16.7857V16.785V16.7843V16.7836V16.7829V16.7822V16.7815V16.7808V16.7801V16.7794V16.7787V16.778V16.7773V16.7766V16.7759V16.7752V16.7745V16.7738V16.7731V16.7724V16.7717V16.771V16.7703V16.7696V16.7689V16.7682V16.7675V16.7668V16.7661V16.7654V16.7647V16.764V16.7633V16.7626V16.7619V16.7612V16.7605V16.7598V16.7591V16.7584V16.7577V16.757V16.7563V16.7556V16.7549V16.7542V16.7535V16.7528V16.7521V16.7515V16.7508V16.7501V16.7494V16.7487V16.748V16.7473V16.7466V16.7459V16.7452V16.7445V16.7438V16.7431V16.7424V16.7417V16.741V16.7403V16.7396V16.7389V16.7382V16.7375V16.7368V16.7361V16.7354V16.7347V16.734V16.7333V16.7327V16.732V16.7313V16.7306V16.7299V16.7292V16.7285V16.7278V16.7271V16.7264V16.7257V16.725V16.7243V16.7236V16.7229V16.7222V16.7215V16.7208V16.7202V16.7195V16.7188V16.7181V16.7174V16.7167V16.716V16.7153V16.7146V16.7139V16.7132V16.7125V16.7118V16.7111V16.7105V16.7098V16.7091V16.7084V16.7077V16.707V16.7063V16.7056V16.7049V16.7042V16.7035V16.7028V16.7022V16.7015V16.7008V16.7001V16.6994V16.6987V16.698V16.6973V16.6966V16.6959V16.6953V16.6946V16.6939V16.6932V16.6925V16.6918V16.6911V16.6904V16.6897V16.689V16.6884V16.6877V16.687V16.6863V16.6856V16.6849V16.6842V16.6835V16.6829V16.6822V16.6815V16.6808V16.6801V16.6794V16.6787V16.678V16.6774V16.6767V16.676V16.6753V16.6746V16.6739V16.6732V16.6726V16.6719V16.6712V16.6705V16.6698V16.6691V16.6684V16.6678V16.6671V16.6664V16.6657V16.665V16.6643V16.6637V16.663V16.6623V16.6616V16.6609V16.6602V16.6596V16.6589V16.6582V16.6575V16.6568V16.6561V16.6555V16.6548V16.6541V16.6534V16.6527V16.6521V16.6514V16.6507V16.65V16.6493V16.6487V16.648V16.6473V16.6466V16.6459V16.6453V16.6446V16.6439V16.6432V16.6425V16.6419V16.6412V16.6405V16.6398V16.6391V16.6385V16.6378V16.6371V16.6364V16.6358V16.6351V16.6344V16.6337V16.633V16.6324V16.6317V16.631V16.6303V16.6297V16.629V16.6283V16.6276V16.627V16.6263V16.6256V16.6249V16.6243V16.6236V16.6229V16.6223V16.6216V16.6209V16.6202V16.6196V16.6189V16.6182V16.6175V16.6169V16.6162V16.6155V16.6149V16.6142V16.6135V16.6128V16.6122V16.6115V16.6108V16.6102V16.6095V16.6088V16.6081V16.6075V16.6068V16.6061V16.6055V16.6048V16.6041V16.6035V16.6028V16.6021V16.6015V16.6008V16.6001V16.5995V16.5988V16.5981V16.5975V16.5968V16.5961V16.5955V16.5948V16.5941V16.5935V16.5928V16.5921V16.5915V16.5908V16.5901V16.5895V16.5888V16.5882V16.5875V16.5868V16.5862V16.5855V16.5848V16.5842V16.5835V16.5829V16.5822V16.5815V16.5809V16.5802V16.5796V16.5789V16.5782V16.5776V16.5769V16.5763V16.5756V16.5749V16.5743V16.5736V16.573V16.5723V16.5716V16.571V16.5703V16.5697V16.569V16.5684V16.5677V16.567V16.5664V16.5657V16.5651V16.5644V16.5638V16.5631V16.5625V16.5618V16.5612V16.5605V16.5598V16.5592V16.5585V16.5579V16.5572V16.5566V16.5559V16.5553V16.5546V16.554V16.5533V16.5527V16.552V16.5514V16.5507V16.5501V16.5494V16.5488V16.5481V16.5475V16.5468V16.5462V16.5455V16.5449V16.5442V16.5436V16.5429V16.5423V16.5417V16.541V16.5404V16.5397V16.5391V16.5384V16.5378V16.5371V16.5365V16.5359V16.5352V16.5346V16.5339V16.5333V16.5326V16.532V16.5314V16.5307V16.5301V16.5301C11.3483 16.5151 11.3485 16.5002 11.3487 16.4853C11.3518 16.238 11.3548 15.9995 11.3381 15.7568L11.2383 15.7636M12.9186 11.3138C12.4027 10.6603 11.6757 10.424 11.0107 10.238L11.0107 10.2379L11.0068 10.237C10.9396 10.221 10.8717 10.2047 10.8034 10.1883C10.7185 10.1679 10.6332 10.1475 10.5485 10.1275L10.5485 10.1275L10.5472 10.1272C10.2734 10.0667 10.0029 9.992 9.7367 9.90352L9.73672 9.90349L9.73411 9.9027C9.61007 9.86519 9.49633 9.79925 9.40185 9.71003C9.30804 9.62145 9.23575 9.51231 9.19061 9.39106C9.15167 9.26222 9.14271 9.12609 9.16443 8.99318C9.18631 8.85934 9.2387 8.73245 9.31748 8.62244L9.31754 8.62249L9.31962 8.61933C9.56848 8.24252 9.92674 8.03997 10.4944 7.98217C11.0511 7.92547 11.5644 8.10693 12.1702 8.59401C12.1702 8.59402 12.1702 8.59402 12.1703 8.59403L12.3335 8.72529L12.4084 8.78558L12.4716 8.71301L13.5662 7.45494L13.653 7.35524L13.5335 7.29885L11.334 6.26147V4.87207V4.77207H11.234H9.75522H9.65522V4.87207V6.39645M12.9186 11.3138L9.65522 6.39645M11.2383 15.7636C11.2548 16.0022 11.2518 16.2369 11.2487 16.4851C11.2485 16.4998 11.2483 16.5146 11.2481 16.5294L13.321 13.7825C13.0577 14.5898 12.3755 15.2145 11.4625 15.465C11.2296 15.5284 11.2253 15.5678 11.2383 15.7636ZM9.65522 6.39645C9.56226 6.42438 9.47072 6.45688 9.38092 6.49385L9.38091 6.49384L9.37967 6.49437C8.22353 6.98867 7.57565 7.80031 7.47716 8.90649L9.65522 6.39645ZM7.94703 10.6327C7.5841 10.1564 7.41798 9.56565 7.47716 8.90652L7.94703 10.6327ZM7.94703 10.6327C8.30933 11.1081 8.8627 11.4629 9.56805 11.6612L7.94703 10.6327Z" stroke="#2D6CB2" strokeOpacity="0.99" strokeWidth="0.2"/>
																			</svg>
																		</span>
																		</td>
																			:
																			null
																		}
																		<td className='notToPrint'>
																			{props.dependent?.access && props.dependent.access.can_update === true
																				?
																				<div className='activityButonAction'>
																					{/*<span className="marginRight10" onClick={() => editAsset(item)}>*/}
																					{/*<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
																					{/*	<path d="M13.293 0.292875C13.683 -0.097625 14.317 -0.097625 14.707 0.292875L18.707 4.29287C19.098 4.68337 19.098 5.31657 18.707 5.70707L5.707 18.7071C5.52 18.8946 5.265 19 5 19H1C0.4477 19 0 18.5523 0 18V14C0 13.7348 0.1054 13.4804 0.2929 13.2929L10.293 3.29307L13.293 0.292875ZM11 5.41417L2 14.4142V17H4.586L13.586 7.99997L11 5.41417ZM15 6.58577L16.586 4.99997L14 2.41417L12.414 3.99997L15 6.58577Z" fill="#71767A" />*/}
																					{/*</svg>*/}
																					{/*</span>*/}
																					<span id={A12Y_CONST.LABEL.ASSET+A12Y_CONST.TEXT.DELETE+item.id} className="deleteIcon cursorPointer" onClick={() => deleteAsset(item,A12Y_CONST.TEXT.ASSET)}>
																			<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
																				<path d="M5 2C5 0.8954 5.89543 0 7 0H13C14.1046 0 15 0.8954 15 2V4H16.9897C16.9959 3.9999 17.0021 3.9999 17.0083 4H19C19.5523 4 20 4.4477 20 5C20 5.5523 19.5523 6 19 6H17.9311L17.0638 18.1425C16.989 19.189 16.1182 20 15.0689 20H4.93112C3.88184 20 3.01096 19.189 2.9362 18.1425L2.06888 6H1C0.44772 6 0 5.5523 0 5C0 4.4477 0.44772 4 1 4H2.99174C2.99795 3.9999 3.00414 3.9999 3.01032 4H5V2ZM7 4H13V2H7V4ZM4.07398 6L4.93112 18H15.0689L15.926 6H4.07398ZM8 8C8.5523 8 9 8.4477 9 9V15C9 15.5523 8.5523 16 8 16C7.44772 16 7 15.5523 7 15V9C7 8.4477 7.44772 8 8 8ZM12 8C12.5523 8 13 8.4477 13 9V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V9C11 8.4477 11.4477 8 12 8Z" fill="#D96941"/>
																			</svg>
																			</span>
																					<span onClick={() => viewDetails(item,A12Y_CONST.TEXT.ASSET)}  className="marginLeft10 ViewIcon">
																<img src={viewIcon} alt='View Icon'/>
															</span>
																				</div>
																				:
																				null
																			}
																		</td>
																	</tr>
																)}
														)
													}
													</tbody>
													<tfoot><tr><td><div className="footer-space">&nbsp;</div></td></tr></tfoot>
												</table>
											)
											:
											(
												<>
												<div className='noData df aic jcc fcol'>
													
													<strong>{A12Y_CONST.TEXT.NO_DATA_FOUND}</strong>
													<p>{A12Y_CONST.TEXT.NO_DATA_FOUND_MESSAGE}</p>
												</div>
												
												</>
											)
									}
								</div>
							}
						</TabPanel>
						<TabPanel value="2">
							{
								props.loadingTransfer ?
								<div className='noData df aic jcc fcol'>
									<div className="positionRelative">
										<div className="dependentLoader">
											<div className='fullWidth justifyCenter marginBottom10'>
												<div className="stage">
													<div className="dot-pulse"></div>
												</div>
											</div>
										</div>
										<div className='marginTop20'>
											<span>{A12Y_CONST.TEXT.LOADING_TRANSFER}</span>
										</div>
									</div>
								</div>
								:
									<div className="tableBody responsiveTalbe activityTableTitle" id='Printable'>
										{
											transferList.length > 0 ?
												(<table cellSpacing="0" cellPadding="0" border="0" className="fullWidth assetTable transferTable" id="TableContent">
														<thead className='mt20'>
														<tr>
															<th className='dateCol'><span onClick={() => sortBy('transferList', transferList, 'transfer_date')} className={`${getClassNamesFor('transfer_date')} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.TRASNFER_DATE} <i className="arrow down"></i></span></th>
															<th className='nameCol'><span onClick={() => sortBy('transferList', transferList, 'asset_name')} className={`${getClassNamesFor('asset_name')} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.ASSET_NAME}<i className="arrow down"></i></span></th>
															<th className='typeCol'><span onClick={() => sortBy('transferList', transferList, 'asset_type')} className={`${getClassNamesFor('asset_type')} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.ASSET_TYPE}<i className="arrow down"></i></span></th>
															<th className='dateCol totalValue'><span onClick={() => sortBy('transferList', transferList, 'net_proceeds')} className={`${getClassNamesFor('net_proceeds')} filterBy df aic cursorPointer tar-print`}>{A12Y_CONST.LABEL.TOTAL_VALUE} <i className="arrow down"></i></span></th>
															<th className='statusCol tac'><span onClick={() => sortBy('transferList', transferList, 'transfer_type')} className={`${getClassNamesFor('transfer_type')} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.STATUS} <i className="arrow down"></i></span></th>
															<th className='actCol notToPrint'></th>
														</tr>
														</thead>
														<tbody>
														{
															transferList.map((item, i) => {

																return (
																	<tr key={i}>
																		<td><span onClick={() => viewDetails(item,A12Y_CONST.TEXT.TRANSFER)} className="h100 df aic cursorPointer marginTop5Imp">{item.transfer_date}</span></td>
																		<td className='ellipsis'><span onClick={() => viewDetails(item,A12Y_CONST.TEXT.TRANSFER)} className="h100 df aic cursorPointer">{item.asset_type === 'Automobile' ? item?.automobile_details?.model_year+' '+item?.automobile_details?.make+' '+item?.automobile_details?.model: item.asset_name}</span></td>
																		<td className='ellipsis'><span onClick={() => viewDetails(item,A12Y_CONST.TEXT.TRANSFER)} className="h100 df aic cursorPointer">{item.asset_type}</span></td>
																		{/*<td><span onClick={() => viewDetails(item,A12Y_CONST.TEXT.TRANSFER)} className="h100 df aic cursorPointer nowrap tar-print">{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(item.net_proceeds)}</span></td>*/}
																		<td><span onClick={() => viewDetails(item,A12Y_CONST.TEXT.TRANSFER)} className="h100 df aic cursorPointer nowrap tar-print">{amoutWithoutDecimal(item.net_proceeds)}</span></td>
																		<td className='tac'>
															<span className='cursorPointer' onClick={() => viewDetails(item,A12Y_CONST.TEXT.TRANSFER)}>
																{
																	<MuiThemeProvider theme={theme}>
																		<Tooltip title={<h2 style={{fontSize: '16px', color:'white', padding: '5px'}}>{item.transfer_type === 2 ? 'Sale' : item.transfer_type === 3 ? 'Gift' : 'Partial sale'}</h2>} placement="left" arrow>
																			{item.transfer_type === 2 ?
																				<svg id={A12Y_CONST.BUTTON_ID.TRANSFER_TYPE} className='transferIco sale' width="25" height="25" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
																					<path d="M14.0001 27.3334C6.63608 27.3334 0.666748 21.3641 0.666748 14.0001C0.666748 6.63608 6.63608 0.666748 14.0001 0.666748C21.3641 0.666748 27.3334 6.63608 27.3334 14.0001C27.3334 21.3641 21.3641 27.3334 14.0001 27.3334ZM14.0001 24.6667C16.8291 24.6667 19.5422 23.5429 21.5426 21.5426C23.5429 19.5422 24.6667 16.8291 24.6667 14.0001C24.6667 11.1711 23.5429 8.458 21.5426 6.45761C19.5422 4.45722 16.8291 3.33341 14.0001 3.33341C11.1711 3.33341 8.458 4.45722 6.45761 6.45761C4.45722 8.458 3.33341 11.1711 3.33341 14.0001C3.33341 16.8291 4.45722 19.5422 6.45761 21.5426C8.458 23.5429 11.1711 24.6667 14.0001 24.6667ZM9.33342 16.6667H16.6667C16.8436 16.6667 17.0131 16.5965 17.1382 16.4715C17.2632 16.3465 17.3334 16.1769 17.3334 16.0001C17.3334 15.8233 17.2632 15.6537 17.1382 15.5287C17.0131 15.4037 16.8436 15.3334 16.6667 15.3334H11.3334C10.4494 15.3334 9.60151 14.9822 8.97639 14.3571C8.35127 13.732 8.00008 12.8841 8.00008 12.0001C8.00008 11.116 8.35127 10.2682 8.97639 9.64306C9.60151 9.01794 10.4494 8.66675 11.3334 8.66675H12.6667V6.00008H15.3334V8.66675H18.6667V11.3334H11.3334C11.1566 11.3334 10.987 11.4037 10.862 11.5287C10.737 11.6537 10.6667 11.8233 10.6667 12.0001C10.6667 12.1769 10.737 12.3465 10.862 12.4715C10.987 12.5965 11.1566 12.6667 11.3334 12.6667H16.6667C17.5508 12.6667 18.3986 13.0179 19.0238 13.6431C19.6489 14.2682 20.0001 15.116 20.0001 16.0001C20.0001 16.8841 19.6489 17.732 19.0238 18.3571C18.3986 18.9822 17.5508 19.3334 16.6667 19.3334H15.3334V22.0001H12.6667V19.3334H9.33342V16.6667Z" fill="#2D6CB2" fillOpacity="0.99"/>
																				</svg>
																				:
																				item.transfer_type === 3 ?
																					<svg id={A12Y_CONST.BUTTON_ID.TRANSFER_TYPE} className='transferIco gift' width="25" height="25" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path d="M19.9999 2.66676C20.9363 2.66664 21.8562 2.91307 22.6671 3.38124C23.4781 3.84942 24.1515 4.52285 24.6196 5.33381C25.0877 6.14478 25.3341 7.06471 25.3339 8.00109C25.3337 8.93747 25.087 9.8573 24.6186 10.6681L30.6666 10.6668V13.3334H27.9999V26.6668C27.9999 27.0204 27.8594 27.3595 27.6094 27.6096C27.3593 27.8596 27.0202 28.0001 26.6666 28.0001H5.33325C4.97963 28.0001 4.64049 27.8596 4.39044 27.6096C4.14039 27.3595 3.99992 27.0204 3.99992 26.6668V13.3334H1.33325V10.6668L7.38125 10.6681C6.71974 9.52261 6.5075 8.17216 6.78576 6.87899C7.06402 5.58581 7.81292 4.44218 8.88703 3.67016C9.96115 2.89814 11.2838 2.55282 12.5982 2.70126C13.9127 2.8497 15.125 3.4813 15.9999 4.47342C16.4994 3.9046 17.1147 3.44912 17.8045 3.13753C18.4944 2.82593 19.2429 2.66542 19.9999 2.66676ZM14.6666 13.3334H6.66658V25.3334H14.6666V13.3334ZM25.3333 13.3334H17.3333V25.3334H25.3333V13.3334ZM11.9999 5.33342C11.3079 5.33033 10.6419 5.59634 10.1424 6.07526C9.64291 6.55418 9.34916 7.20851 9.3232 7.90001C9.29723 8.59151 9.54109 9.26602 10.0032 9.78105C10.4654 10.2961 11.1097 10.6113 11.7999 10.6601L11.9999 10.6668H14.6666V8.00009C14.6666 7.36284 14.4384 6.74664 14.0234 6.2631C13.6083 5.77956 13.0338 5.46063 12.4039 5.36409L12.1986 5.34009L11.9999 5.33342ZM19.9999 5.33342C19.3271 5.33321 18.6792 5.5873 18.1859 6.04475C17.6925 6.50221 17.3904 7.12922 17.3399 7.80009L17.3333 8.00009V10.6668H19.9999C20.6727 10.667 21.3207 10.4129 21.814 9.95543C22.3073 9.49797 22.6095 8.87096 22.6599 8.20009L22.6666 8.00009C22.6666 7.29285 22.3856 6.61457 21.8855 6.11447C21.3854 5.61437 20.7072 5.33342 19.9999 5.33342Z" fill="#2D6CB2" fillOpacity="0.99"/>
																					</svg>
																					:
																					<svg id={A12Y_CONST.BUTTON_ID.TRANSFER_TYPE} className='transferIco partial' width="25" height="25" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path fillRule="evenodd" clipRule="evenodd" d="M16.5 4C23.4036 4 29 9.59573 29 16.4984C29 23.4011 23.4036 28.9968 16.5 28.9968H16.4999C9.7513 28.9968 4.25179 23.6495 4.00832 16.9612H4.00841C4.00282 16.8076 4 16.6533 4 16.4984C4 9.59573 9.59644 4 16.5 4ZM6.7778 16.4985C6.7778 16.6536 6.78144 16.8079 6.78862 16.9612H12.0245C12.0244 16.9613 12.0244 16.9614 12.0243 16.9615H21.9009C21.901 16.9614 21.901 16.9613 21.9011 16.9612H26.2114C26.2186 16.8079 26.2222 16.6536 26.2222 16.4985C26.2222 11.1297 21.8695 6.77751 16.5 6.77751C11.1306 6.77751 6.7778 11.1297 6.7778 16.4985Z" fill="#2D6CB2"/>
																					</svg>
																			}
																		</Tooltip>
																	</MuiThemeProvider>
																}
															</span>
																		</td>
																		<td className='notToPrint'>
																			{props.dependent?.access && props.dependent.access.can_update === true
																				?
																				<div className='activityButonAction'>
																					{/*<span className="marginRight10" onClick={() => editAsset(item)}>
																		<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
																			<path d="M13.293 0.292875C13.683 -0.097625 14.317 -0.097625 14.707 0.292875L18.707 4.29287C19.098 4.68337 19.098 5.31657 18.707 5.70707L5.707 18.7071C5.52 18.8946 5.265 19 5 19H1C0.4477 19 0 18.5523 0 18V14C0 13.7348 0.1054 13.4804 0.2929 13.2929L10.293 3.29307L13.293 0.292875ZM11 5.41417L2 14.4142V17H4.586L13.586 7.99997L11 5.41417ZM15 6.58577L16.586 4.99997L14 2.41417L12.414 3.99997L15 6.58577Z" fill="#71767A" />
																		</svg>
																	</span>*/}
																			<span id={A12Y_CONST.BUTTON_TEXT.TRANSFER+A12Y_CONST.TEXT.DELETE+item.id} className="deleteIcon cursorPointer" onClick={() => deleteAsset(item,A12Y_CONST.TEXT.TRANSFER)}>
																		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
																			<path d="M5 2C5 0.8954 5.89543 0 7 0H13C14.1046 0 15 0.8954 15 2V4H16.9897C16.9959 3.9999 17.0021 3.9999 17.0083 4H19C19.5523 4 20 4.4477 20 5C20 5.5523 19.5523 6 19 6H17.9311L17.0638 18.1425C16.989 19.189 16.1182 20 15.0689 20H4.93112C3.88184 20 3.01096 19.189 2.9362 18.1425L2.06888 6H1C0.44772 6 0 5.5523 0 5C0 4.4477 0.44772 4 1 4H2.99174C2.99795 3.9999 3.00414 3.9999 3.01032 4H5V2ZM7 4H13V2H7V4ZM4.07398 6L4.93112 18H15.0689L15.926 6H4.07398ZM8 8C8.5523 8 9 8.4477 9 9V15C9 15.5523 8.5523 16 8 16C7.44772 16 7 15.5523 7 15V9C7 8.4477 7.44772 8 8 8ZM12 8C12.5523 8 13 8.4477 13 9V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V9C11 8.4477 11.4477 8 12 8Z" fill="#D96941"/>
																		</svg>
																	</span>
																					<span onClick={() => viewDetails(item,A12Y_CONST.TEXT.TRANSFER)}  className="marginLeft10 ViewIcon">
																		<img src={viewIcon} alt='View Icon'/>
																	</span>
																				</div>
																				:
																				null
																			}
																		</td>
																	</tr>
																)
															})

														}
														</tbody>
														<tfoot><tr><td><div className="footer-space">&nbsp;</div></td></tr></tfoot>
													</table>
												)
												:
												(
												!props.loadingTransfer && transferList.length === 0 &&
													<div className='noData df aic jcc fcol'>
														<strong>{A12Y_CONST.TEXT.NO_DATA_FOUND}</strong>
														<p>{A12Y_CONST.TEXT.NO_DATA_FOUND_MESSAGE}</p>
													</div>
												)
										}
									</div>
							}
						</TabPanel>
						<TabPanel value="3">

							{
								props.loadingDebt ?
								<div className='noData df aic jcc fcol'>
									<div className="positionRelative">
										<div className="dependentLoader">
											<div className='fullWidth justifyCenter marginBottom10'>
												<div className="stage">
													<div className="dot-pulse"></div>
												</div>
											</div>
										</div>
										<div className='marginTop20'>
											<span>{A12Y_CONST.TEXT.LOADING_DEBTS}</span>
										</div>
									</div>
								</div>
									:
									<div className="tableBody responsiveTalbe activityTableTitle" id='Printable'>
										{
											debtList.length > 0 ?
												(<table cellSpacing="0" cellPadding="0" border="0" className="fullWidth liabilitiesInventory" id="TableContent">
													<thead className='mt20'>
													<tr>
														<th className='dateCol'><span onClick={() => sortBy('debtList', debtList, 'as_of_date')} className={`${getClassNamesFor('as_of_date')} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.DATE} <i className="arrow down"></i></span></th>
														<th><span onClick={() =>sortBy('debtList', debtList, 'debt_type')} className={`${getClassNamesFor('debt_type')} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.DEBT_TYPE}<i className="arrow down"></i></span></th>
														<th className='typeCol'><span onClick={() => sortBy('debtList', debtList, 'owed_to')} className={`${getClassNamesFor('owed_to')} filterBy df aic cursorPointer`}>{A12Y_CONST.LABEL.OWED_TO} <i className="arrow down"></i></span></th>
														<th className='amtCol'><span onClick={() => sortBy('debtList', debtList, 'debt_value')} className={`${getClassNamesFor('debt_value')} filterBy df aic cursorPointer tar-print`}>{A12Y_CONST.LABEL.AMOUNT} <i className="arrow down"></i></span></th>
														<th className='actCol notToPrint'></th>
													</tr>
													</thead>
													<tbody>
													{
														debtList.map((item, i) => {
															return (
																<tr key={i}>
																	<td><span onClick={() => viewDebtDetails(item)} className="h100 df aic cursorPointer">{item.as_of_date}</span></td>
																	<td className='ellipsis'><span onClick={() => viewDebtDetails(item)} className="h100 df aic cursorPointer">{item.debt_type}</span></td>
																	<td className='ellipsis'><span onClick={() => viewDebtDetails(item)} className="h100 df aic cursorPointer">{item.owed_to}</span></td>
																	{/*<td><span onClick={() => viewDebtDetails(item)} className="h100 df aic cursorPointer nowrap tar-print">{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(item.debt_value)}</span></td>*/}
																	<td><span onClick={() => viewDebtDetails(item)} className="h100 df aic cursorPointer nowrap tar-print">{amoutWithoutDecimal(item.debt_value)}</span></td>
																	<td className='notToPrint'>
																		{props.dependent?.access && props.dependent.access.can_update === true
																			?
																	<div className='activityButonAction liabilitiesButtonAction'>
																	<span className="marginRight10 cursorPointer" onClick={() => editDebts(item)}>
																		<svg id={A12Y_CONST.TEXT.DEBT+A12Y_CONST.TEXT.EDIT+item.id} width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
																			<path d="M13.293 0.292875C13.683 -0.097625 14.317 -0.097625 14.707 0.292875L18.707 4.29287C19.098 4.68337 19.098 5.31657 18.707 5.70707L5.707 18.7071C5.52 18.8946 5.265 19 5 19H1C0.4477 19 0 18.5523 0 18V14C0 13.7348 0.1054 13.4804 0.2929 13.2929L10.293 3.29307L13.293 0.292875ZM11 5.41417L2 14.4142V17H4.586L13.586 7.99997L11 5.41417ZM15 6.58577L16.586 4.99997L14 2.41417L12.414 3.99997L15 6.58577Z" fill="#2D6CB2" />
																		</svg>
																	</span>
																				<span className="deleteIcon cursorPointer" onClick={() => deleteAsset(item,A12Y_CONST.TEXT.DEBTS)}>
																		<svg id={A12Y_CONST.TEXT.DEBT+A12Y_CONST.TEXT.DELETE+item.id} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
																			<path d="M5 2C5 0.8954 5.89543 0 7 0H13C14.1046 0 15 0.8954 15 2V4H16.9897C16.9959 3.9999 17.0021 3.9999 17.0083 4H19C19.5523 4 20 4.4477 20 5C20 5.5523 19.5523 6 19 6H17.9311L17.0638 18.1425C16.989 19.189 16.1182 20 15.0689 20H4.93112C3.88184 20 3.01096 19.189 2.9362 18.1425L2.06888 6H1C0.44772 6 0 5.5523 0 5C0 4.4477 0.44772 4 1 4H2.99174C2.99795 3.9999 3.00414 3.9999 3.01032 4H5V2ZM7 4H13V2H7V4ZM4.07398 6L4.93112 18H15.0689L15.926 6H4.07398ZM8 8C8.5523 8 9 8.4477 9 9V15C9 15.5523 8.5523 16 8 16C7.44772 16 7 15.5523 7 15V9C7 8.4477 7.44772 8 8 8ZM12 8C12.5523 8 13 8.4477 13 9V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V9C11 8.4477 11.4477 8 12 8Z" fill="#D96941"/>
																		</svg>
																	</span>
																		<span onClick={() => viewDebtDetails(item)}  className="marginLeft10 ViewIcon">
																		<img  id={A12Y_CONST.TEXT.DEBT+A12Y_CONST.TEXT.VIEW+item.id}  src={viewIcon} alt='View Icon'/>
																	</span>
																			</div>
																			:
																			null
																		}
																	</td>
																</tr>
															)
														})
													}
													</tbody>
													<tfoot><tr><td><div className="footer-space">&nbsp;</div></td></tr></tfoot>
												</table>)
												:
												(
													!props.loadingDebt && debtList.length === 0 &&
													<div className='noData df aic jcc fcol'>
														<strong>{A12Y_CONST.TEXT.NO_DATA_FOUND}</strong>
														<p>{A12Y_CONST.TEXT.NO_DATA_FOUND_MESSAGE}</p>
													</div>
												)
										}
									</div>
							}
						</TabPanel>
					</TabContext>
				</div>
            </div>

			<TransferPopUpComponent
				popUpStatus={isTransferPopUp}
				//assetData={assetDate}
				title='Report Sale of Property'
				buttonDeleteTxt='Cancel'
				buttonCancelTxt='Save'
				currentAsset={props.currentAsset}
				hidePopUp={hideTransferPopUp}
				onSubmit={handleSave}
				loading={props.transferPopupLoader}
				dependent={props.dependent}
				isDataChanged={dataChangeHandler}
				error={props.transferError}
				errorMessage={props.errorMessage}
				message={props.message}

			/>

			<PopUpIncomeExpComponent
				popUpStatus={isPopUp}
				title={A12Y_CONST.TEXT.ARE_YOU_SURE_YOU_WANT_TO_DELETE_TEXT}
				message={A12Y_CONST.LABEL.ANY_EDITS_YOU}
				buttonDeleteTxt={A12Y_CONST.BUTTON_TEXT.YES}
				buttonCancelTxt={A12Y_CONST.BUTTON_TEXT.NO}
				hidePopUp={hidePopUp}
				handleDeleteButton={handleDeleteButton}
			/>

			<ReportProcessingPopupComponent
				isOpen={isNotificationPopupOpen}
				onClose={() => setIsNotificationPopupOpen(false)}
			/>
        </div>
    )
}

export default InventoryListComponent
